import { AllSocietyStateType } from './Types';

export const allSocietyInitialState: AllSocietyStateType = {
	loading: false,
	error: null,
	data: null,
};
